import styled from '@emotion/styled';

/* eslint-disable-next-line */
export interface TimeComponentsProps {}

const StyledTimeComponents = styled.div`
  color: pink;
`;

export function TimeComponents(props: TimeComponentsProps) {
  return (
    <StyledTimeComponents>
      <h1>Welcome to TimeComponents!</h1>
    </StyledTimeComponents>
  );
}

export default TimeComponents;
